import { render, staticRenderFns } from "./DefaultModalContent.vue?vue&type=template&id=4d5679f3"
import script from "./DefaultModalContent.vue?vue&type=script&lang=js"
export * from "./DefaultModalContent.vue?vue&type=script&lang=js"
import style0 from "./DefaultModalContent.vue?vue&type=style&index=0&id=4d5679f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports